import React from 'react';
import {Header, List, Modal} from "semantic-ui-react";
import Conditions from "./whatsCovered/conditions";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getLocalization, interpolateString} from "../utils/localization";
import {getArrayByLanguage, isAIG, isNationwide} from "../utils/common";
import {ClickableText, CustomModalHeader} from "./custom-common";
import {BenefitLimitsRequest} from "../services/types";
import {benefitLimitsService} from "../services/services";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData} = state;
    const {policy, ratedClass, contractInfo, limitations} = initialData;

    return {
        ...ownProps,
        ageReduction: policy.ageReduction,
        ageReductionAge: policy.ageReductionAge,
        ageReductionPercentage: policy.ageReductionPercentage,
        benefitWaitingPeriod: policy.benefitWaitingPeriod,
        severeSeparationPeriod: policy.severeSeparationPeriod,
        moderateSeparationPeriod: policy.moderateSeparationPeriod,
        catastrophicSeparationPeriod: policy.catastrophicSeparationPeriod,
        catastrophicMaximumOccurrences: policy.catastrophicRecurrencyLimit,
        lang: user.lang,
        limitations,
        contractTerms: ratedClass.contractTerms,
        statePostalCode: contractInfo.issueState,
    }
};

const LimitationsExclusionsContent = (props) => {
    const { ageReduction, ageReductionAge, ageReductionPercentage, benefitWaitingPeriod, lang, limitations,
        benefitLimitsData, contractTerms, statePostalCode } = props;
    const localization = getLocalization(lang);
    const filteredExclusions = getArrayByLanguage(limitations, lang);
    const strings = localization.limitationsAndExclusions;

    const [benefitLimits, setBenefitLimits] = React.useState(null);
    React.useEffect(() => {
        if (!!benefitLimitsData) {
            setBenefitLimits(benefitLimitsData);
        } else if (!benefitLimits) {
            async function getBenefitLimits() {
                const payload = new BenefitLimitsRequest({
                    contractTerms,
                    languageCode: lang,
                    statePostalCode
                })
                const data = await benefitLimitsService(payload)
                return data;
            }

            getBenefitLimits().then(benefitLimitsData => setBenefitLimits(benefitLimitsData));
        }
    }, [benefitLimitsData, benefitLimits, contractTerms, statePostalCode, lang]);

    return (<>
        <Header as={'h3'}>{strings.title}</Header>
        <p>{strings.aCompleteDescr}</p>
        <p style={{fontSize: '16px'}}><b>{strings.limitations}</b></p>
        <p>{strings.brellaWillPay}{benefitLimits?.subjectToText}. {benefitLimits?.adminChangeText}</p>
        <div style={{marginLeft: '1.5em'}}>
            {benefitLimits?.explanations?.map(({title, description}) =>
                <p key={title}><b>{title}:</b><br/>{description}</p>
            )}
        </div>

        <br/>
        <p style={{fontSize: '16px'}}><b>{strings.exclusions}</b></p>
        {filteredExclusions.map((item, i) => <React.Fragment key={i}>
            <p>{item.title}</p>
            <div style={{marginLeft: '1.5em'}}>
                <List className={'limitationsAndExclusionsList'}>
                    {item.items.map((it) => <List.Item key={it.bullet}>{it.bullet}) {it.title}</List.Item>)}
                </List>
            </div>
            {i !== filteredExclusions.length - 1 && <br/>}
        </React.Fragment>)}

        {!!ageReduction &&
            <React.Fragment>
                <br/>
                <p style={{fontSize: '16px'}}><b>{strings.reductionsOfCoverage}</b></p>
                <p>{interpolateString(strings.benefitsMayBeReduced, [ageReductionAge, ageReductionPercentage])}</p>
            </React.Fragment>}

        {!!benefitWaitingPeriod &&
            <>
                <br/>
                <p style={{fontSize: '16px'}}><b>{strings.waitingPeriods}</b></p>
                <p>{interpolateString(strings.ifYouEnroll, [benefitWaitingPeriod])} {benefitLimits?.coveredDuringBenefitWaitingPeriodText} {!isNationwide() && benefitLimits?.waitingPeriodsAdditionalText}</p>
            </>
        }

        <br/>
        {!isAIG() &&
            <>
                <p style={{fontSize: '16px'}}><b>{strings.renew}</b></p>
                <p>{strings.ourPlansAre}</p>
                <br/>
            </>
        }
    </>);
}


const CoveredModal = (props) => {
    const {displayCoveredModal, localization, onModalClose: propsOnModalClose} = props;
    const strings = localization.whatsCovered;
    const stringsLE = localization.limitationsAndExclusions;

    const [renderLimitationsAndExclusionsModal, setRenderLimitationsAndExclusionsModal] = React.useState(false);
    const [title, setTitle] = React.useState(<></>);


    React.useEffect(() => {
        let titleCandidate;
        if (renderLimitationsAndExclusionsModal) {
            titleCandidate = <span>{'<'}{' '}
                <ClickableText onClick={setRenderLimitationsAndExclusionsModalFalse}>
                {stringsLE.backToCond}
            </ClickableText></span>;
        } else {
            titleCandidate = <div style={{display: 'inline-block'}}>{strings.title}</div>;
        }
        setTitle(titleCandidate);
    }, [renderLimitationsAndExclusionsModal, strings, stringsLE]);

    const setRenderLimitationsAndExclusionsModalTrue = () => {
        setRenderLimitationsAndExclusionsModal(true)
    }

    const setRenderLimitationsAndExclusionsModalFalse = () => {
        setRenderLimitationsAndExclusionsModal(false)
    }

    const onModalClose = () => {
        setRenderLimitationsAndExclusionsModalFalse();
        propsOnModalClose();
    }

    return (
        <Modal style={{marginTop: '1rem'}}
               onClose={onModalClose}
               open={displayCoveredModal}>
            <CustomModalHeader title={title} onClose={onModalClose}/>
            <Modal.Content style={{minHeight: '45em', maxHeight: '45em', overflowY: 'auto'}}>
                { renderLimitationsAndExclusionsModal ? <LimitationsExclusionsContent {...props} /> : <Conditions /> }
            </Modal.Content>
            <Modal.Actions className={'modalActionsAlignLeft'}>
                {!renderLimitationsAndExclusionsModal &&
                    <ClickableText onClick={setRenderLimitationsAndExclusionsModalTrue} small>
                        {strings.viewLimit}→
                    </ClickableText>}
            </Modal.Actions>
        </Modal>
    );
}

export default withRouter(connect(mapStateToProps)(CoveredModal));
